/* eslint-disable */

import { getLangURL } from './language';

import { detectLanguage } from 'i18n';

export const getLinkLoginSSO = (language: string, clientId?: string) => `${process.env.REACT_APP_SSO_URL}/OAuth/Auth?response_type=code&client_id=${clientId || ''}&scope=Online-Read+Online-Write&redirect_uri=${encodeURIComponent(`${window.location.origin}${getLangURL(language)}/login-sso`)}`;
// export const getLinkLoginSSO = (language: string, clientId?: string) => 'https://trading.vcbs.com.vn/';

export const getRedirectSSOParam = (timeout?: string, language?: string) => `${window.location.origin}${getLangURL(detectLanguage())}/login-sso?TimeOut=${timeout || ''}&Language=${
  language || ''
}`;

export const getLinkLogoutSSO = (accessToken: string, urlCallback?: string) => `${process.env.REACT_APP_SSO_URL}/Account/LogOffRemote?b=${accessToken ? `Bearer ${accessToken}` : ''}&returnUrl=${urlCallback || ''}`;
